import { apiClient } from "@/services/api";

export default {
  // CSRF & AUTH
  getAll() {
    return apiClient.get("/media");
  }
};
